import axios from 'axios';

export default {
    remove(id) {
        return axios.post('/priceLine/remove/', { id });
    },
    manualCheck(id, value) {
        return axios.post('/priceLine/manualCheck/', { id, value });
    },
    update(payload) {
        return axios.post('/priceLine/update/', payload);
    },
    add(payload) {
        return axios.post('/priceLine/add/', payload);
    },
};
